import { useEffect as e, useRef as t } from "react";
//#region src/hooks/use-state-watcher.ts
function n(n, r) {
	let i = t(null);
	e(() => {
		r(i.current, n), i.current = n;
	}, [n]);
}
//#endregion
export { n as useStateWatcher };
